<template>
  <aside class="col-12 col-md-2 p-0 bg-dark admin-menu">
    <nav class="navbar navbar-expand navbar-dark bg-dark flex-md-column flex-row align-items-start">
      <div class="collapse navbar-collapse mx-auto mt-3">
        <ul class="flex-md-column flex-row navbar-nav w-100 justify-content-between">
          <a class="navbar-brand" href="/"></a>
          <li class="nav-item">
            <router-link class="nav-link pl-0" to="/admin/events">
              <i class="fas fa-route mr-3"></i> {{ $t('pages.admin.Events') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link pl-0" to="/admin/users">
              <i class="fas fa-users mr-3"></i> {{ $t('pages.admin.Users') }}
            </router-link>
          </li>

          <li class="nav-item">
            <a href="https://mail136.websupport.sk/" target="_blank" class="nav-link pl-0">
              <i class="far fa-envelope mr-3"></i> {{ $t('pages.admin.Email') }}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </aside>
</template>

<script>
    export default {
        name: 'Nav'
    };
</script>

<style scoped>
</style>
